import { __decorate, __extends } from "tslib";
import { CustomElement, attachShadowTemplate, upgradeProperty, coerceNumber, FoundationProperty } from '@tyler-components-web/core';
import { FooterFoundation } from './footer-foundation';
import { FooterAdapter } from './footer-adapter';
import { FOOTER_CONSTANTS } from './footer-constants';
import { FooterItemComponent } from '../footer-item';
var template = require('./footer.html');
var styles = require('./footer.css');
var FooterComponent = /** @class */ (function (_super) {
    __extends(FooterComponent, _super);
    function FooterComponent() {
        var _this = _super.call(this) || this;
        attachShadowTemplate(_this, FOOTER_CONSTANTS.elementName, template, styles);
        _this._foundation = new FooterFoundation(new FooterAdapter(_this));
        return _this;
    }
    Object.defineProperty(FooterComponent, "observedAttributes", {
        get: function () {
            return [
                FOOTER_CONSTANTS.attributes.LAYOUT,
                FOOTER_CONSTANTS.attributes.LAYOUT_BREAKPOINT
            ];
        },
        enumerable: true,
        configurable: true
    });
    FooterComponent.prototype.initializedCallback = function () {
        upgradeProperty(this, 'layout');
        upgradeProperty(this, 'layoutBreakpoint');
    };
    FooterComponent.prototype.connectedCallback = function () {
        this._foundation.initialize();
    };
    FooterComponent.prototype.disconnectedCallback = function () {
        this._foundation.disconnect();
    };
    FooterComponent.prototype.attributeChangedCallback = function (name, oldValue, newValue) {
        switch (name) {
            case FOOTER_CONSTANTS.attributes.LAYOUT:
                this.layout = newValue;
                break;
            case FOOTER_CONSTANTS.attributes.LAYOUT_BREAKPOINT:
                this.layoutBreakpoint = coerceNumber(newValue);
                break;
        }
    };
    __decorate([
        FoundationProperty()
    ], FooterComponent.prototype, "layout", void 0);
    __decorate([
        FoundationProperty()
    ], FooterComponent.prototype, "layoutBreakpoint", void 0);
    FooterComponent = __decorate([
        CustomElement({
            name: FOOTER_CONSTANTS.elementName,
            dependencies: [FooterItemComponent]
        })
    ], FooterComponent);
    return FooterComponent;
}(HTMLElement));
export { FooterComponent };
